import { Link } from 'react-router-dom';

export const UserAgreementConsent = () => (
  <>
    I have read and agree to the Realbricks{' '}
    <a
      href='https://www.web.realbricks.com/legal#Terms%20of%20use'
      target='_blank'
      rel='noopener noreferrer'
      className='fw-600 underline'
    >
      Terms of Service
    </a>{' '}
    and{' '}
    <a
      href='https://www.web.realbricks.com/legal#Privacy%20Policy'
      target='_blank'
      rel='noopener noreferrer'
      className='fw-600 underline'
    >
      Privacy Policy
    </a>
    .
  </>
);

export const  TextMessageConsent = () => (
  <>
    By checking this box, I consent to receive customer care and marketing text messages from Realbricks including account updates and important notifications, such as early access to new properties, exclusive offers, and other promotional content. Message and data rates may apply. I understand that my consent is not a condition of purchase, and I can opt-out at any time by replying STOP. Reply HELP for help. Message frequency varies. View{' '}
    <Link to={{ pathname: '/legal', hash: 'Privacy Policy' }} target='_blank' className='fw-600 underline'>
      Privacy Policy
    </Link>{' '}
    &{' '}
    <Link to={{ pathname: '/legal', hash: 'SMS Communications Policy' }} target='_blank' className='fw-600 underline'>
      SMS Communications
    </Link>.
  </>
);
